import classNames from 'classnames'
import { EntityId, TemporalEntityId } from 'entities-next/common'
import React from 'react'
import { makeStyles } from 'tss-react/mui'
import { FormViews } from 'utils-next/forms'
import { ExtendableStyles, Testable } from 'utils-next/types'

import { Theme } from '@mui/material'

import { FundingRound } from '../FundingRound'
import { AddNewFundingRound } from './AddNewFundingRound.component'
import { useFundingRoundListData } from './FundingRoundList.container'

export type FundingRoundListProps = ExtendableStyles &
  Testable & {
    organizationId: EntityId
  }

export function FundingRoundList({ className, organizationId, ...otherProps }: FundingRoundListProps) {
  const {
    fundingRoundList,
    handlers: { addNewFundingRound, updateFundingRound, deleteFundingRound },
  } = useFundingRoundListData(organizationId)
  const { classes } = useStyles()
  return (
    <div className={classNames(className, classes.fundingRoundContainer)} {...otherProps}>
      {fundingRoundList.map((fundingRound) => {
        const initialView = fundingRound.id === TemporalEntityId.new ? FormViews.edit : FormViews.view
        return (
          <FundingRound
            className={classes.fundingRound}
            key={`fundingRound-${fundingRound.id}-${fundingRound.createdAt}`}
            data={fundingRound}
            initialView={initialView}
            onUpdate={updateFundingRound}
            onDelete={() => deleteFundingRound(fundingRound)}
            editable
          />
        )
      })}

      <AddNewFundingRound onCreate={addNewFundingRound} />
    </div>
  )
}

const useStyles = makeStyles()(({ spacing }: Theme) => ({
  fundingRoundContainer: {
    position: 'relative',
    display: 'flex',
    flexDirection: 'column',
  },
  fundingRound: {
    marginBottom: spacing(2),
  },
}))
